import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { StorageService } from 'src/app/root/_services/storage.service';
import { TranslateService } from '@ngx-translate/core';
import { Lingua } from 'src/app/main/_models/lingua';
import { LanguageService } from 'src/app/root/_services/language.service';
import { AlertService } from 'src/app/root/_services/alert.service';
import { AuthenticationService } from 'src/app/root/_services/authentication.service';
import { UserService } from 'src/app/root/_services/user.service';
import { delay, first } from 'rxjs/operators';
import { Router, ActivatedRoute } from '@angular/router';
import { SaveTempService } from 'src/app/root/_services/save-temp.service';
import { CheckProfileService } from 'src/app/root/_services/check-profile.service';
import { AppConfig } from 'src/app/app.config';
import { ApiResponse } from 'src/app/main/_models/api-response';
import { BaseController } from 'src/app/shared/base-controller';

@Component({
	selector: 'app-login',
	templateUrl: './login.component.html',
	styleUrls: ['./login.component.scss']
})
export class LoginComponent extends BaseController {

	loginFormGroup: FormGroup;
	listLanguages: Array<Lingua>;
	returnUrl: string;
	versione: string;
	versioneBE: string;
	forgot: boolean;
	//label: [];
	fromActivate: string;
	forceValidation = false;

	constructor(
		private fb: FormBuilder,
		private storageService: StorageService,
		private translateService: TranslateService,
		private languageService: LanguageService,
		private alertService: AlertService,
		private authenticationService: AuthenticationService,
		private usersService: UserService,
		private router: Router,
		private saveTempService: SaveTempService,
		private checkprofileService: CheckProfileService,
		private route: ActivatedRoute,
		private config: AppConfig) { 
			super();
			this.storageService.clearLocal("access_token");
			this.storageService.clear("access_token");
		}

	ngOnInit() {
		super.ngOnInit();
		this.versione = this.config.getVersion("semverString");
		this.createForm();
		this.loadLanguages();
		//this.loadLabels();
		this.checkLoginRemember();
		this.fromActivate = this.route.snapshot.queryParams["a"];
		this.authenticationService.getBackendVersion().subscribe(x => {
			if(x.status == "OK")
				this.versioneBE = x.result;
			else
				this.alertService.error(x.error_message ? x.error_message : "System error");
		});
		this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || null;
	}

	// loadLabels() {
	// 	this.label = this.translateService.instant([
	// 		"login.inserire_la_mail",
	// 		"login.invio_mail_password_dimenticata",
	// 		"login.dati_di_accesso_non_validi"
	// 	]);
	// 	console.log(this.label);
	// }

	checkLoginRemember() {

		let rememberToken = this.storageService.getItemLocalPlain("access_token");
		if (rememberToken) {
			this.subs.push(this.authenticationService.loginRemember(rememberToken)
				.pipe(first())
				.subscribe(data => this.afterLogin(data)));
		}
		else{
			this.saveTempService.empty();
			this.authenticationService.logout(false).pipe(delay(0));
		}
	}

	createForm() {
		this.loginFormGroup = this.fb.group({
			"email": ["", [Validators.required, Validators.email]],
			"password": ["", Validators.required],
			"remember": [false],
			"mkt": "",
			"profilo": "P",
			"returnUrl": [""]
		});
	}

	loadLanguages() {
		this.subs.push(this.languageService.getAll()
			.subscribe(
				data => {
					if (data.status == "OK")
						this.listLanguages = this.languageService.mapLanguages(data.result.data);
					else {
						this.alertService.error(data.error_message);
						this.listLanguages = [];
					}
				},
				error => {
					this.alertService.error(error);
				}

			));
	}

	onSubmit() {
		this.forgot = false;
		this.forceValidation = false;
		if (this.canSubmit())
			this.login();
		else
			this.forceValidation = true;
	}

	register() {
		this.router.navigate(["/register"]);
	}

	login() {
		this.loginFormGroup.patchValue({"returnUrl": this.returnUrl});
		this.subs.push(this.authenticationService.login(this.loginFormGroup.value).subscribe(
			data => this.afterLogin(data)));
	}

	afterLogin(data: ApiResponse) {
		if (data.status === 'OK' && data.result && data.result.jwt)
			this.checkprofileService.getMessages();
		else if (data.status === 'OK')
			this.alertService.error(this.translateService.instant("login.dati_di_accesso_non_validi"));
		else{
			this.alertService.error(data.error_message);
			this.saveTempService.empty();
			this.authenticationService.logout(false).pipe(delay(0));
		}
	}

	canSubmit(): boolean {
		return this.loginFormGroup.valid && this.loginFormGroup.dirty;
	}

	useLanguage(language: string) {
		this.storageService.storePlain('language', language);
		this.translateService.use(language);
	}

	forgotPassword() {

		this.forgot = true;

		if (this.loginFormGroup.get("email").errors) {
			this.alertService.error(this.translateService.instant("login.inserire_la_mail"));
			return;
		}

		this.subs.push(this.usersService.forgotPassword(this.loginFormGroup.get("email").value)
			.subscribe(
				data => {

					if (data.status == "OK") {
						this.alertService.success(this.translateService.instant("login.invio_mail_password_dimenticata"));
						this.forgot = false;
					}

					else
						this.alertService.error(data.error_message);


				},
				error => {
					this.alertService.error(error);
				}

			));

	}

}
